import { styled } from '@mui/material/styles';
import BackgroundContainerStyled from './BackgroundContainerStyled';

export default styled(BackgroundContainerStyled)({
  touchAction: 'auto !important'
});